module.exports = require("./ksh.d.ts");